import { createFileRoute } from '@tanstack/react-router';

import { preloadProgressData } from 'hooks/useQuery/useQueryProgressData';

import { MySourceView } from 'views/MySourceView';

export const Route = createFileRoute('/_auth/_layout/my-source/')({
  component: MySourceView,
  staticData: {
    disablePointBar: true,
  },

  loader: async ({ context }) => {
    const { queryClient } = context;

    context.back = {
      to: '/home/',
    };

    await preloadProgressData(queryClient);
  },
});
